import { Route, Routes } from "react-router-dom";
import { SiteFooter } from "./components/SiteFooter";
import { AuthResumeRedirect, RequireAuth, SignInPage } from "./lib/auth";
import { Home } from "./pages/Home";
import {
  ContactPage,
  PrivacyPage,
  RefundsPage,
  TermsPage,
} from "./pages/Legal";
import { CustomWork } from "./pages/CustomWork";
import { NotFound } from "./pages/NotFound";
import { OrderPlace } from "./pages/OrderPlace";
import { Orders } from "./pages/Orders";
import { QuotePage } from "./pages/Quote";

export function App() {
  return (
    <>
    <AuthResumeRedirect />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/quote" element={<QuotePage />} />
      <Route
        path="/custom-work"
        element={
          <RequireAuth>
            <CustomWork />
          </RequireAuth>
        }
      />
      <Route
        path="/order/:quoteId"
        element={
          <RequireAuth>
            <OrderPlace />
          </RequireAuth>
        }
      />
      <Route
        path="/orders"
        element={
          <RequireAuth>
            <Orders />
          </RequireAuth>
        }
      />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/refunds" element={<RefundsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <SiteFooter />
    </>
  );
}
